import { createContext } from 'react';
export const BroadcastChannelContext = createContext(null);
